(() => {
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  try {
    if (!reduced && !sessionStorage.getItem('sa-ie-visited')) {
      root.classList.add('sa-ie-rewind');
      setTimeout(() => root.classList.remove('sa-ie-rewind'), 1000);
    }
    sessionStorage.setItem('sa-ie-visited', '1');
  } catch (_) {}
  document.querySelectorAll('[data-sa-ie-back]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      if (history.length > 1 && document.referrer && new URL(document.referrer).origin === location.origin) history.back();
      else location.assign(button.dataset.home);
    });
  });
})();